export interface ContraAccountModel {
  accountNumber: string;
  id: string;
  financialInstituteId: string;
  mandateId: string | null;
  signatureDate: string;
  utcInsertDate: string;
  utcUpdateDate: string;
  version: string;
  hasPendingIbanModification: boolean;
}

export class ContraAccount implements ContraAccountModel {
  accountNumber = "";
  id = "";
  financialInstituteId = "";
  mandateId = "";
  signatureDate = "";
  utcInsertDate = "";
  utcUpdateDate = "";
  version = "";
  hasPendingIbanModification = false;

  constructor(dto?: ContraAccount) {
    if (dto) {
      Object.assign(this, dto);
    }
  }
}
